<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 
-->
<template>
  <el-tag
    class="lc-tag"
    :closable="closable"
    :effect="effect"
    :size="size"
    :type="type"
  >
    {{ reLabel }}
  </el-tag>
</template>
<script>
import { getDictItem } from '@/apis/application/dict.js';
import { mapGetters } from 'vuex';
export default {
  name: 'LcTag',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    closable:{
      type: Boolean,
      default: false
    },
    effect:{
      type: String,
      default: 'light'
    },
    size:{
      type: String,
      default: ''
    },
    type:{
      type: String,
      default: ''
    },
    label:{
      type: String,
      default: '标签'
    },
    optionsDict: {
      type: [String, Number],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      reOptions: []
    };
  },
  computed: {
    ...mapGetters({
      appId: 'appId',
    }),
    reLabel() {
      const reOption = this.reOptions.find(e => e.value === this.value)
      return reOption?.label || this.label
    },
  },
  created() {
    this.loadOptions()
  },
  methods: {
    async loadOptions() {
      if (this.optionsDict) {
        const res = await getDictItem(this.appId, {
          dictCode: this.optionsDict,
          pageIndex: 1,
          pageSize: 999
        })
        this.reOptions = res.data ? res.data.map(item => {
          return {
            label: item.itemLabel,
            value: item.itemValue,
          }
        }) : []
      } else {
        this.reOptions = this.options || []
      }
    }
  },
};
</script>
